import { Col, Image, Row } from "react-bootstrap";
import { neturalBlack } from "../../constants/color";
import CustomLinkButtonWithIcon from "../link-button-with-icon/link-button-with-icon.component";

const EmptyProductList = () =>{
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "89%",
      }}
    >
      <Row style={{ display: "flex", justifyContent: "center" }}>
        <Col
          lg="12"
          md="12"
          sm="12"
          xs="12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Image
            src="./images/EmptyProduct.png"
            alt="No Product"
            style={{
              objectFit: "contain",
              width: "246.59px",
              height: "216.72px",
            }}
          />
        </Col>
        <Col
          lg="12"
          md="12"
          sm="12"
          xs="12"
          style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
        >
          <label
            style={{ fontSize: "24px", fontWeight: "700", color: neturalBlack }}
          >
            No product listed yet
          </label>
        </Col>
        <Col lg="4" md="4" sm="4" xs="4"></Col>
        <Col
          lg="4"
          md="4"
          sm="4"
          xs="4"
          style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
        >
          <label style={{ fontSize: "16px", textAlign: "center" }}>
            You don’t have any product listed. Start now by creating your first
            product.
          </label>
        </Col>
        <Col lg="4" md="4" sm="4" xs="4"></Col>
        <Col lg="4" md="4" sm="4" xs="4">
          <CustomLinkButtonWithIcon linkToNavigate={"create"} title={"Add Product"} />
        </Col>
      </Row>
    </div>
  );
}

export default EmptyProductList;
